import { useParams } from 'react-router-dom';

import TeamsOverview from '../../features/teams/layouts/overview';
import CreateTeamForm from '../../features/teams/forms/create';
import EditTeamForm from '../../features/teams/forms/edit';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
//
//   /admin/teams      → the list
//   /admin/teams/new  → the create form, via `mode` (static route, no param)
//   /admin/teams/:id  → the edit form, with its members panel

export default function TeamsPage({ mode }) {
    const { id } = useParams();

    if (mode === 'create' || id === 'new') return <CreateTeamForm />;
    if (id) return <EditTeamForm teamId={id} />;
    return <TeamsOverview />;
}
